// extracted by mini-css-extract-plugin
export default {"wrapper":"Copy_wrapper__uLrvZ","text":"Copy_text__ZvvpY","copy":"Copy_copy__Yuzzz","stroke":"Copy_stroke__FfatZ","checkIcon":"Copy_checkIcon__pcq-S"};